import { useState } from 'preact/hooks'
import { buzz, copy } from './lib'

interface Props {
  label: string
  value: string
  /** 主要結果用強調樣式，完整網址用次要樣式。 */
  emphasis?: boolean
}

/** 一行網址 + 複製按鈕。純網址與完整網址共用。 */
export function CopyRow({ label, value, emphasis = false }: Props) {
  const [state, setState] = useState<'idle' | 'ok' | 'fail'>('idle')

  async function onCopy() {
    const outcome = await copy(value)
    if (outcome === 'copied') buzz()
    setState(outcome === 'copied' ? 'ok' : 'fail')
    setTimeout(() => setState('idle'), 1600)
  }

  return (
    <div class={emphasis ? 'card p-4' : 'card p-3.5'}>
      <div class="mb-2 flex items-center justify-between gap-3">
        <span
          class={
            emphasis
              ? 'text-xs font-semibold tracking-wide text-indigo-600 uppercase dark:text-cyan-300'
              : 'text-xs font-medium tracking-wide text-slate-400 uppercase dark:text-slate-500'
          }
        >
          {label}
        </span>
        <button
          type="button"
          onClick={onCopy}
          class={`btn shrink-0 px-3 py-1.5 text-xs ${emphasis ? 'btn-primary' : 'btn-ghost'}`}
        >
          {state === 'ok' ? '已複製 ✓' : state === 'fail' ? '複製失敗' : '複製'}
        </button>
      </div>
      <p
        class={`url ${
          emphasis ? 'text-slate-900 dark:text-slate-50' : 'text-slate-500 dark:text-slate-400'
        }`}
      >
        {value}
      </p>
    </div>
  )
}
